// @ts-nocheck
import { Overlay } from '@angular/cdk/overlay';
import { CdkPortal, TemplatePortal } from '@angular/cdk/portal';
import { NgClass, NgStyle } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import {
  OverlayHelper,
  overlayUserConfiguration,
} from '../../../../helpers/_old_helpers/overlayHelperClass';
import { ErrorOverlayClass } from '../../error-overlay/error-overlay.directive';
import { InputTextCondensedComponent } from '../input-text-condensed/input-text-condensed.component';

@Component({
  selector: 'lbca-select-condensed',
  templateUrl: './select-condensed.component.html',
  styleUrl: './select-condensed.component.scss',
  imports: [InputTextCondensedComponent, CdkPortal, NgClass, NgStyle],
})
export class SelectCondensedComponent implements AfterViewInit {
  @ViewChild('mainElement', { static: true }) mainElement!: ElementRef;
  @ViewChild('templateAppend', { static: true }) templateAppend!: TemplatePortal;

  private errorPopup!: ErrorOverlayClass;
  private selectOverlay!: OverlayHelper;

  public hasError: boolean = false;
  public autoSort: boolean = true;

  public componetHelperIconStyle: any = null;

  private option: any[] = [];
  private valUnsorted: any[] = [];
  public optionFiltered: any[] = [];
  public chosed: boolean = false;
  public optionRestored: any[] = [];

  public labelValue: string = '';
  public helperTextValue: string = '';
  public isRequired: boolean = false;
  public isDisabled: boolean = false;
  public isLabeled: boolean = false;
  public isTabeled: boolean = false;
  public isEditable: boolean = false;

  private valueSelected: any = null;
  public errorList: any = null;
  public valueInput: any = null;

  @Input() set tabeled(value: boolean) {
    this.isTabeled = value;
  }
  @Input() set labeled(value: boolean) {
    this.isLabeled = !value;
  }
  @Input() set editable(value: boolean) {
    this.isEditable = value;
  }
  @Input() set require(status: boolean) {
    this.isRequired = status;
  }
  @Input() set disabled(disabled: boolean) {
    this.isDisabled = disabled;
  }
  @Input() set helperText(value: string) {
    this.helperTextValue = value;
  }
  @Input() set label(value: string) {
    this.labelValue = value;
  }

  @Input('sort')
  set sortItens(order: boolean) {
    if (order !== undefined && order !== null) {
      this.autoSort = order;
      this.option = [...this.optionRestored];
    }
  }

  @Input('options')
  set optionsList(val: any) {
    if (!val) return;
    const valSorted = this.autoSort ? val.sort((a, b) => a.label.localeCompare(b.label)) : val;
    this.option = valSorted;
    this.optionFiltered = valSorted;
    this.calcHeightProp();
  }
  @Input() set value(value: string) {
    if (value) {
      this.valueSelected = value;
      if (this.valueSelected) {
        const select = this.option.find((opt) => opt.id === this.valueSelected);

        if (select) this.valueInput = select.label;
      }
    }
  }

  @Input('error')
  set err(error: any) {
    if (error && error.length > 0) {
      this.hasError = true;
      this.errorPopup.setErrors(error);
    } else {
      this.hasError = false;
      this.errorPopup.setErrors([]);
    }
  }

  @Output() focusState = new EventEmitter();
  @Output('changeValue') changeEmmiter = new EventEmitter();
  @Output('changeLabelValue') changeLabelEmmiter = new EventEmitter();
  @Output('errorState') setErrorEmmiter = new EventEmitter();

  public bindProperties: any = {
    width: 320,
    height: 240,
  };

  public componetIconStyle = 'svg-icon-angle bg-gray-600 transition duration-400 ease-in-out';

  constructor() {
    const overlay = inject(Overlay);
    const elementRef = inject(ElementRef);

    this.selectOverlay = new OverlayHelper(overlay);

    this.errorPopup = new ErrorOverlayClass(overlay);
    this.errorPopup.setPosition(
      elementRef,
      [
        {
          originX: 'end',
          originY: 'top',
          overlayX: 'end',
          overlayY: 'bottom',
        },
      ],
      0,
      0,
      'bottom',
      'end'
    );
  }

  ngAfterViewInit(): void {
    const wid = this.calcWidth();
    const mainElementWid = Math.round(
      this.mainElement!.nativeElement.getBoundingClientRect().width
    );

    this.bindProperties.width = wid > mainElementWid ? wid : mainElementWid;

    const config: overlayUserConfiguration = {
      positionStrategy: 'flexible',
      scrollStrategy: 'close',
      offsetY: 16,
      connectedTo: this.mainElement!,
      flexiblePositionStrategy: [
        {
          originX: 'start',
          originY: 'bottom',
          overlayX: 'start',
          overlayY: 'top',
        },
      ],
    };

    this.selectOverlay.setConfiguration(config);
  }

  private calcWidth() {
    const body = document.body,
      html = document.documentElement;

    const maxWindowSize = Math.max(
      body.scrollWidth,
      body.offsetWidth,
      html.clientWidth,
      html.scrollWidth,
      html.offsetWidth
    );

    let maiorLen = 0;
    this.option.forEach((item) => {
      if (item.label.length > maiorLen) maiorLen = item.label.length;
    });
    const calc = maiorLen * 5;

    return calc > maxWindowSize ? maxWindowSize : calc;
  }

  public changeEvent(event: any): void {
    const value = event.target.value;
    this.chosed = false;
    if (value)
      this.componetHelperIconStyle =
        'svg-icon-search bg-gray-600 transition duration-400 ease-in-out';
    else this.componetHelperIconStyle = null;

    this.optionFiltered = this.option.filter((opt) => RegExp(value, 'ig').test(opt.label));
    this.calcHeightProp();
  }

  public selectOption($event: MouseEvent, option: any): void {
    this.chosed = true;
    this.valueInput = option.label;
    this.valueSelected = option.id;
    this.changeEmmiter.emit(option.id);
    this.changeLabelEmmiter.emit(option.label);
    this.setErrorEmmiter.emit([]);
  }

  private calcHeightProp(): void {
    const length = this.optionFiltered.length;

    let size = 220;
    if (length >= 5) size = 220;
    else if (length === 1) size = 44;
    else if (length === 0) size = 32;
    else size = length * 44;

    this.bindProperties.height = size;
  }

  public click() {
    const focusedElement = document.activeElement;
    if (focusedElement instanceof HTMLInputElement) {
      this.componetIconStyle =
        'svg-icon-angle bg-primary transition duration-400 ease-in-out rotate-180';
      this.openSelectBox();
    }
  }

  public setFocus(focus: any): void {
    this.focusState.emit(focus);
    if (focus) {
      this.componetIconStyle =
        'svg-icon-angle bg-primary transition duration-400 ease-in-out rotate-180';
      this.openSelectBox();
    } else {
      this.componetIconStyle = 'svg-icon-angle bg-gray-600 transition duration-400 ease-in-out';
      this.closeSelectBox();
      if (!this.chosed) {
        this.valueInput = '';
        this.componetHelperIconStyle = null;
        this.optionFiltered = [...this.option];
        this.calcHeightProp();
      }
    }
  }

  private openSelectBox(): void {
    this.selectOverlay.show(this.templateAppend);
    this.errorPopup.setFocus(true);
  }

  private closeSelectBox(): void {
    setTimeout(() => {
      this.selectOverlay.close();
      this.errorPopup.setFocus(false);
    }, 150);
  }

  public setErrorControllEmmiter($event) {
    this.setErrorEmmiter.emit($event);
  }
}
